import { useCallback, useEffect, useState } from 'react';
import useDownloadCsv from './index';
import { UseDownloadCsvParams } from '@common/types';

type UseDownloadCsvSafeParams = Omit<UseDownloadCsvParams, 'shouldDownload'>;

export const useDownloadCsvSafe = (params: UseDownloadCsvSafeParams) => {
  const [shouldDownload, setShouldDownload] = useState(false);
  
  const { refetch: downloadCsv, isLoading } = useDownloadCsv({
    shouldDownload,
    endpoint: params.endpoint,
    params: params.params,
    filename: params.filename,
  });

  // Only trigger download when shouldDownload state changes to true
  useEffect(() => {
    if (shouldDownload) {
      downloadCsv();
      setShouldDownload(false);
    }
  }, [shouldDownload, downloadCsv]);

  // Safe click handler that prevents multiple rapid clicks
  const handleDownloadClick = useCallback(() => {
    if (!isLoading) {
      setShouldDownload(true);
    }
  }, [isLoading]);

  return { handleDownloadClick, isLoading };
};

export default useDownloadCsvSafe;
